import MobileTable from './MobileTable';

export default MobileTable;
